// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"9eb3f7fe","977":"fae75cd1"}[chunkId] + ".chunk.js";
};